import Layout from "../Layout";

const About = () => {
  return (
    <Layout>
      <h1 style={{ margin: "5rem 0", textAlign: "center" }}>About Page</h1>
    </Layout>
  );
};

export default About;
